import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Typography from '../../../UniformComponents/Typography'
import DerivedChartSlot from './components/DerivedChartSlot'

const Derived = observer(({ store }) => (
    <div className="pp-slide-layout-container">
        <div className="pp-slide-commentary-container">
            <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
        </div>

        <br />

        <div className="pp-chart-slot-container">
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', backgroundColor: 'white', borderRadius: 6, padding: '5px 10px' }}>
                <DerivedChartSlot
                    store={store}
                    chartKey={`${store.activeSlide.id}-${0}`}
                    position={0}
                />

                <div style={{ display: 'flex', gap: 5, justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                    <Typography type="tiny">Weaker correlation</Typography>

                    <div style={{ height: 3, width: '70%', backgroundColor: 'black' }} />

                    <Typography type="tiny">Stronger correlation</Typography>
                </div>
            </div>
        </div>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 50 }}>
            <Typography type="tiny">{`${R.pathOr('', ['kpiQuestionLongText'], store.activeSlide?.question.get(0))} vs ${R.pathOr('', ['questionLongText'], store.activeSlide?.question.get(0))}. Size of the bubble reflects the proportion of respondents who held the objective`}</Typography>

            <div style={{ textAlign: 'right', minWidth: 150 }}>
                <Typography type="tiny">{i18n.t('powerpoint.slide.derived-correlation-weak')}</Typography>

                <Typography type="tiny">{i18n.t('powerpoint.slide.derived-correlation-moderate')}</Typography>

                <Typography type="tiny">{i18n.t('powerpoint.slide.derived-correlation-strong')}</Typography>
            </div>
        </div>
    </div>
))

export default Derived
